/* List of Redux constants */
export const VACANCY_SET_SUMMARY_LOADING = '@vacancies/set-summary-loading';
export const VACANCY_SET_FORM_LOADING = '@vacancies/set-form-loading';
export const VACANCY_SET_QUESTIONS_LOADING = '@vacancies/set-questions-loading';
export const VACANCY_SET_APPLICATIONS_LOADING = '@vacancies/set-applications-loading';
export const VACANCY_SET_VACANCY_POSTING = '@vacancies/set-vacancy-posting';
export const VACANCY_SET_VACANCY_PUTTING_ON_HOLD = '@vacancies/set-vacancy-putting-on-hold';
export const VACANCY_SET_VACANCY_RE_POSTING = '@vacancies/set-vacancy-re-posting';
export const VACANCY_SET_VACANCY_ARCHIVING = '@vacancies/set-vacancy-archiving';
export const VACANCY_SET_QUESTIONS = '@vacancies/set-questions';
export const VACANCY_SET_PUBLIC_PRESCREENING_QUESTIONS_LOADING = '@vacancies/set-public-prescreening-questions-loading';
export const VACANCY_SET_PUBLIC_PRESCREENING_QUESTIONS = '@vacancies/set-public-prescreening-questions';
export const VACANCY_SET_PUBLIC_APPLICATION_LOADING = '@vacancies/set-public-application-loading';
export const VACANCY_SET_PUBLIC_APPLICATION_ERRORS = '@vacancies/set-public-application-errors';
export const VACANCY_SET_PUBLIC_APPLICATION_STATUS = '@vacancies/set-public-application-status';
export const VACANCY_SET_PUBLIC_APPLICATION = '@vacancies/set-public-application';
export const VACANCY_RESET_PUBLIC_APPLICATION = '@vacancies/reset-public-application';
export const VACANCY_SET_SUMMARY = '@vacancies/set-summary';
export const VACANCY_SET_APPLICATIONS = '@vacancies/set-applications';
export const VACANCY_SET_SUMMARY_ERROR = '@vacancies/set-summary-error';
export const VACANCY_RESET_PUBLIC_PRESCREENING_QUESTIONS = '@vacancies/reset-public-prescreening-questions';
export const VACANCY_RESET_QUESTIONS = '@vacancies/reset-questions';
export const VACANCY_RESET_SUMMARY = '@vacancies/reset-summary';
export const VACANCY_RESET_APPLICATIONS = '@vacancy/reset-applications';
export const VACANCY_SET_APPLICATIONS_QUERY_PARAMS = '@vacancy/set-applications-query-params';
export const VACANCY_SET_SELECTED_APPLICATION_IDS = '@vacancy/set-selected-applciation-ids';
export const VACANCIES_SET_VACANCY_KEEPING_POSTED = '@vacancies/set-vacancy-keeping-posted';
export const VACANCIES_SET_VACANCY_REMAINING_ON_HOLD = '@vacancies/set-vacancy-remaining-on-hold';
export const VACANCY_SET_QUESTION_ADDING = '@vacancies/set-question-adding';
export const VACANCY_SET_QUESTION_DELETING = '@vacancies/set-question-deleting';
export const VACANCY_SET_VACANCY_DUPLICATION_FORM_DATA_LOADING = '@vacancy/set-vacancy-duplication-form-data-loading';
export const VACANCY_SET_DUPLICATED_VACANCY = '@vacancy/set-duplicated-vacancy';
export const VACANCY_RESET_VACANCY_DUPLICATION_STATE = '@vacancy/reset-vacancy-duplication-state';
export const VACANCY_SET_DUPLICATED_VACANCY_HAS_BEEN_POSTED = '@vacancy/set-duplicated-vacancy-has-been-posted'
export const VACANCY_SET_NOT_HIRED_APPLICATIONS_TO_INVITE_TO_DUPLICATED_VACANCY = '@vacancy/set-not-hired-applications-to-invite-to-duplicated-vacancy';
export const VACANCY_SET_DUPLICATED_VACANCY_REFERENCE_DATA = '@vacancy/set-duplicated-vacancy-reference-data';
export const SCHOOL_VACANCY_INVITATIONS_SET_INVITING_PRIOR_CANDIDATES = `@vacancies/set-inviting-prior-candidates`;
export const SCHOOL_VACANCY_INVITATIONS_SET_INVITING_BY_EMAILS = `@vacancies/set-inviting-by-emails`;
export const VACANCIES_SET_DRAFT_VACANCY_DELETING = '@vacancies/set-draft-vacancy-deleting';
export const VACANCIES_SET_PRINT_VERSION_IS_LOADING = `@vacancies/set-print-version-is-loading`;

/* List of Sagas constants */
export const VACANCIES_ADD_VACANCY = '@vacancies/add-vacancy';
export const VACANCIES_UPDATE_SUMMARY = '@vacancies/update-summary';
export const VACANCIES_POST_VACANCY = '@vacancies/post-vacancy';
export const VACANCIES_PUT_ON_HOLD_VACANCY = '@vacancies/put-on-hold-vacancy';
export const VACANCIES_RE_POST_VACANCY = '@vacancies/re-post-vacancy';
export const VACANCIES_ARCHIVE_VACANCY = '@vacancies/archive-vacancy';
export const VACANCIES_GET_DATA_FOR_DUPLICATE_VACANCY = '@vacancies/get-data-for-duplicate-vacancy';
export const VACANCY_GET_QUESTIONS = '@vacancies/get-questions';
export const VACANCY_GET_PUBLIC_PRESCREENING_QUESTIONS = '@vacancies/get-public-prescreening-questions';
export const VACANCY_GET_PUBLIC_APPLICATION = '@vacancies/get-public-application';
export const VACANCY_CREATE_PUBLIC_APPLICATION = '@vacanciest/create-public-application';
export const VACANCY_ADD_QUESTION = '@vacancies/add-question';
export const VACANCY_REMOVE_QUESTION = '@vacancies/remove-question';
export const VACANCY_GET_SUMMARY = '@vacancies/get-summary';
export const VACANCIES_KEEP_POSTED_VACANCY = '@vacancies/keep-posted-vacancy';
export const VACANCIES_REMAIN_ON_HOLD_VACANCY = '@vacancies/remain-on-hold-vacancy';
export const VACANCY_GET_APPLICATIONS = '@vacancies/get-applications';
export const VACANCY_GET_NOT_HIRED_APPLICATIONS_TO_INVITE_TO_DUPLICATED_VACANCY = '@vacancy/get-not-hired-applications-to-invite-to-duplicated-vacancy';
export const SCHOOL_SEND_PRIOR_CANDIDATES_INVITATIONS = `@vacancies/send-prior-candidates-invitations`;
export const SCHOOL_SEND_BY_EMAILS_INVITATIONS = `@vacancies/send-by-emails-invitations`;
export const VACANCIES_DELETE_DRAFT_VACANCY = '@vacancies/delete-draft-vacancy';
export const VACANCIES_PRINT_VACANCY_APPLICATIONS = `@vacancies/print-vacancy-applications`;



// WEBPACK FOOTER //
// ./src/actions/vacancies/types.js